<template>
  <v-container class="py-5">
    <!-- Trois états, et non deux : sans le troisième, un échec de chargement laissait la page
         sur « Chargement… » indéfiniment — un écran vide qui ne dit ni ce qui manque ni quoi
         faire. Le message d'échec est en `role="alert"` (RGAA), l'attente en `role="status"`. -->
    <p v-if="loadFailed" role="alert">
      Cette fiche n'a pas pu être chargée. Elle ne vous est peut-être plus proposée — revenez à la liste de vos
      activités.
    </p>
    <p v-else-if="!action" role="status">Chargement de l'action…</p>

    <template v-else>
      <v-row justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-card outlined>
            <v-card-title class="font-weight-bold text-center w-100">
              {{ action.study.title }}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-subtitle class="font-weight-bold">Durée</v-card-subtitle>
            <v-card-text>{{ action.study.durationInDay }} jours</v-card-text>
            <v-card-subtitle class="font-weight-bold">Description générale</v-card-subtitle>
            <v-card-text>{{ action.study.descriptionGeneral }}</v-card-text>
            <v-card-subtitle class="font-weight-bold">Description de la scène</v-card-subtitle>
            <v-card-text>{{ action.study.descriptionScene }}</v-card-text>
            <v-card-subtitle class="font-weight-bold">Description de l'influence</v-card-subtitle>
            <v-card-text>{{ action.study.descriptionInfluence }}</v-card-text>
            <v-card-subtitle class="font-weight-bold">Conditions nécessaires</v-card-subtitle>
            <v-card-text>{{ action.study.conditions }}</v-card-text>
            <v-spacer></v-spacer>
            <v-btn @click="download" class="mb-3">Télécharger</v-btn>
          </v-card>
        </v-col>
      </v-row>

      <!-- Restitution avant / après de l'effet de l'action sur la cantine (agrégat d'établissement).
           Réservée au pilotage : l'endpoint est gardé sur le périmètre de gestion, et un convive y
           recevait un 404 rendu en alerte rouge sous un titre « Efficacité de l'action » qui ne le
           concerne pas. C'est aussi de la minimisation — un agrégat d'établissement n'a pas à être
           servi à qui mange à la cantine. -->
      <v-row v-if="action.canteen && !isConsumer" justify="center">
        <v-col cols="12" sm="8" md="6">
          <action-efficacy :canteen-id="action.canteen.id" :action-id="action.id" />
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import ActionEfficacy from "./ActionEfficacy.vue"

export default {
  name: "ActionDetails",
  components: { ActionEfficacy },
  data() {
    return {
      action: null,
      loadFailed: false,
    }
  },
  computed: {
    isConsumer() {
      const user = this.$store.state.loggedUser
      return !!user && user.job === "CONSUMER"
    },
  },
  methods: {
    fetchCurrentPage() {
      const id = this.$route.params.id
      this.$store
        .dispatch("fetchActionDetails", { id })
        .then((response) => {
          this.action = response
        })
        .catch(() => {
          this.loadFailed = true
          this.$store.dispatch("notifyServerError")
        })
    },
    download() {
      const win = window.open("", "", "height=700,width=900")
      win.document.write(`
        <html>
          <head>
            <title>${this.action.study.title}</title>
            <style>
              body { font-family: sans-serif; margin: 20px; }
            </style>
          </head>
          <body>
            <h1>${this.action.study.title}</h1>
            <hr/>
            <h2>Durée</h2>
            <p>${this.action.study.durationInDay}</p>
            <h2>Description général</h2>
            <p>${this.action.study.descriptionGeneral}</p>
            <h2>Description de la scène</h2>
            <p>${this.action.study.descriptionScene}</p>
            <h2>Description de l'influence</h2>
            <p>${this.action.study.descriptionInfluence}</p>
            <h2>Conditions nécessaires</h2>
            <p>${this.action.study.conditions}</p>
          </body>
        </html>
      `)
      win.document.close()
      win.focus()
      win.print()
      win.close()
    },
  },
  mounted() {
    this.fetchCurrentPage()
  },
}
</script>
